import React from "react";
import { globalDestinations } from "../components/DestinationsSection";
import "./DestinationPages.css";

const AsiaDestinations = () => {
  return (
    <div className="dest-page">
      <h2>Featured Destinations Across Asia</h2>
      <div className="dest-grid">
        {globalDestinations.map((place) => (
          <div key={place.id} className="dest-card">
            <img src={place.images[0]} alt={place.title} />
            <h3>{place.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsiaDestinations;
